import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Link } from 'react-router-dom';
import { useStateValue } from '../contextapi/context';
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
const BestProd = ({ src ,id , title ,amountold ,amount,rating}) => {
    const[state ,dispatch] = useStateValue();
   
    const addtobasket =() => {
        
        dispatch(
            {
                    type: 'addtobasket',
                    item : {
                            productname : id,
                            productimage : src,
                            productid : id,
                            productoldprice : id,
                            productprice : id,
                            
                          
                    }
            }
        )
   
        
    
    
      }
    
    return (

           <>


            <div className='BEstsellmainbox' key={id}>
            
            <Link to ={`/singleproduct/${id}`} style={{textDecoration:"none"}} >
                <div className="bestsellleftpart"><img src={src} alt="" />
                </div>

  </Link>

                <div className="rightside">
                <Link to ={`/singleproduct/${id}`} style={{textDecoration:"none"}} >

                    <div><div className="bestitemname">{title}</div>
                        <div className="besstprodcutrating"> {Array(rating)
                            .fill()
                            .map((_, i) => (
                                <p>⭐</p>
                            ))} </div></div>


                    <div>

                    </div>
                    <div className='bestkalast'>
                        <div class="price-box __web-inspector-hide-shortcut__">
                            <del class="old-product-price strong-400 bastsellnormalprice">Rs {amountold}</del>
                            <span class="product-price strong-600 bastsellnormalprice">Rs {amount}</span>
                        </div>

                        <div className="shopingboxbestsell" ><ShoppingCartOutlinedIcon onClick={addtobasket} />
                     </div>


                    </div>
  </Link>

                
                </div>






        
             
    
            </div>


            </>

    );
}
export default BestProd